import axios from 'axios';
import { StatusCodes } from 'http-status-codes';

import Notification from '../components/Notification/Notification.jsx';
import i18n from '../i18n';
import { isPublicPath } from '../routing/publicRoutes';

import baseServerUrl from './apiServer';

const t = (key) => i18n.t(key, { ns: 'common' });

axios.defaults.withCredentials = true;

const baseService = axios.create({
  baseURL: `${baseServerUrl}/api/v10`,
});

baseService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === StatusCodes.UNAUTHORIZED) {
      const currentPath = window.location.pathname;
      if (!isPublicPath(currentPath)) {
        window.location.replace(`${baseServerUrl}/login`);
        return new Promise(() => {});
      }
    }
    if (error.response.status === StatusCodes.TOO_MANY_REQUESTS) {
      Notification.error(t('notifications.tooManyRequests'));
    }
    return Promise.reject(error instanceof Error ? error : new Error(error));
  }
);

export default baseService;
